export const OpenLayersVisualizerMapType = 'openLayersMap';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/open-layer-visualizers/open-layer-visualizers.module.ts